import type { i18n as I18nInstance } from 'i18next';
import { useEffect, useMemo } from 'react';
import type { ReactNode } from 'react';
import { I18nextProvider } from 'react-i18next';

import { createFiltersI18n } from './createFiltersI18n';

type Props = {
  language: string;
  parentI18n?: I18nInstance;
  children: ReactNode;
};

export function FiltersI18nProvider({ language, parentI18n, children }: Props) {
  const i18n = useMemo(() => createFiltersI18n(parentI18n), [parentI18n]);

  useEffect(() => {
    void i18n.changeLanguage(language);
  }, [i18n, language]);

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}
